import { get } from 'svelte/store';
import feedStore from './feed';
import * as entityStorage from './entities';



function queryItemsWithTags(tags) {
    const itemRecords = entityStorage.queryItemsWithTags(tags);
    const itemsDict = get(feedStore).items;
    const linkSet = new Set();
    const items = itemRecords
        .map(itemRecord => {
            const [itemID, linkIdentifier] = itemRecord;
            if (linkSet.has(linkIdentifier)) return;
            linkSet.add(linkIdentifier)
            return itemsDict[itemID];
        })
        .filter(item => item);

    return items;
}

function getItemIdsWithTags(tags) {
    return entityStorage.queryItemsWithTags(tags);
}

function queryLinkedItems(item) {
    const itemID = item.id;
    if (!itemID) {
      return {
        linkedItemsIDs: [],
        linkedItemCount: 0,
      }
    }
    const itemRecords = entityStorage.queryLinkedItems(itemID);
    const linkSet = new Set();
    const items = Object.entries(
        itemRecords.map(itemRecord => {
            const [linkedItemID, tagName, linkIdentifier] = itemRecord;
            if (linkSet.has(linkIdentifier)) return;
            if (linkedItemID === itemID) return;
            linkSet.add(linkIdentifier)
            return [tagName, linkedItemID];
        }).filter(item => item).reduce((acc, [tagName, linkedItemID]) => {
            if (!(tagName in acc)) {
                acc[tagName] = [];
            }
            acc[tagName].push(linkedItemID);
            return acc;
        }, {})
    ).map(([tagName, linkedItemIDs]) => ([tagName, linkedItemIDs]))

    return {
        linkedItemsIDs: items,
        linkedItemCount: items.length
    }
}

function queryAllItems(){
    const items = Object.values(get(feedStore).items);
    return items.sort((a, b) => new Date(b.addedAt || b.pubDate) - new Date(a.addedAt || a.pubDate));
}

function queryNotesWithTags(tags) {
    const noteIds = entityStorage.queryNotesWithTags(tags);
    const notesDict = get(feedStore).notes;
    return noteIds
        .map(noteId => notesDict[noteId])
        .filter(note => note);
}

function queryGetNoteWithId(noteID) {
    const notesDict = get(feedStore).notes;
    return notesDict[noteID.startsWith('n') ? noteID : `n${noteID}`];
}

function queryGetNoteWithUuid(noteUid) {
    const notesDict = get(feedStore).notes;
    const key = notesDict[noteUid];
    return notesDict[key];
}

function queryGetSources(withCounts=false) {
    if (withCounts) {
        return entityStorage.queryAllSourcesWithItemCounts();
    }
    return entityStorage.queryAllSources()
}

function queryGetItemsWithSources(sources) {
    const itemsDict = get(feedStore).items;
    return entityStorage
        .queryItemsWithSources(sources)
        .map(itemId => itemsDict[itemId])
        .filter(item => item)
        .sort((a, b) => new Date(b.addedAt || b.pubDate) - new Date(a.addedAt || a.pubDate));
}

function updateNoteContent(noteUid, sourceMap) {
    const content = Object.values(sourceMap);
    feedStore.updateNoteContent({ noteUid, content });
}

function stringifyNoteContent(noteContentArray) {
    return (noteContentArray || []).join(' ')
}

function setAuth({ isAuthenticated, role, currentUserID }) {
    if (typeof(currentUserID) === 'string') {
        currentUserID = parseInt(currentUserID)
    }
    // set values in store and localStorage
    feedStore.setAuth({
        isAuthenticated,
        role,
        currentUserID,
    });

    if (isAuthenticated) {
        window.localStorage.setItem('isAuthenticated', true);
    }
    if (role) {
        window.localStorage.setItem('role', role);
    }
    if (currentUserID) {
        window.localStorage.setItem('currentUserID', currentUserID);
    }
}

function clearAuth() {
    // clear values from store and localStorage
    feedStore.setAuth({
        isAuthenticated: false,
        role: null,
        currentUserID: null,
    })
    window.localStorage.removeItem('isAuthenticated');
    window.localStorage.removeItem('role');
    window.localStorage.removeItem('currentUserID');
}

function getAuth() {
    const { isAuthenticated, role, roleValue } = get(feedStore);
    return {
        isAuthenticated,
        role,
        roleValue,
    }
}

function addItems({
    items,
    tagsToAdd,
}) {
    feedStore.addItems({ items });
    entityStorage.addItems(items)
    if (tagsToAdd) {
        entityStorage.addTagsToItem(
            items.map(i => i.id),
            tagsToAdd
        )
    }
}

function updateItems({
    itemIDs,
    tagsToAdd,
    tagsToRemove,
    // groupsToAdd,
    // groupsToRemove,
}) {
    entityStorage.addTagsToItem(itemIDs, tagsToAdd)
    feedStore.updateItemTags({ itemIDs, tagsToAdd, tagsToRemove })
}

export {
    queryItemsWithTags,
    getItemIdsWithTags,
    queryLinkedItems,
    queryNotesWithTags,
    queryGetNoteWithId,
    queryGetNoteWithUuid,
    updateNoteContent,
    queryAllItems,
    updateItems,
    addItems,

    queryGetItemsWithSources,
    queryGetSources,

    stringifyNoteContent,

    getAuth,
    setAuth,
    clearAuth,
}